// 负责获取 S3 上的清单（支持新旧两种结构），带本地缓存（ETag）
import localArray from './svglist.json'; // 旧版本地数组 fallback（字符串数组）

const DEFAULT_MANIFEST_URL =
  'https://pladdypusv3.s3.ap-southeast-2.amazonaws.com/public/svglist.json';
const DEFAULT_BASE_URL =
  'https://pladdypusv3.s3.ap-southeast-2.amazonaws.com/public/';
const LS_KEY = 'icon_manifest_cache_v1';

// Local-only icons can be added here without waiting for the S3 manifest to update.
const LOCAL_ICON_OVERRIDES = [
  { name: 'Bed', value: 'spot_icons/Bed.svg', url: '/spot_icons/Bed.svg' },
  { name: 'Dining', value: 'spot_icons/Dining.svg', url: '/spot_icons/Dining.svg' },
  { name: 'Breakfast', value: 'spot_icons/Breakfast.svg', url: '/spot_icons/Breakfast.svg' },
  { name: 'Beach', value: 'spot_icons/Beach.svg', url: '/spot_icons/Beach.svg' },
  { name: 'Pool', value: 'spot_icons/Pool.svg', url: '/spot_icons/Pool.svg' },
  { name: 'Spa', value: 'spot_icons/Spa.svg', url: '/spot_icons/Spa.svg' },
  { name: 'Wellness', value: 'spot_icons/Wellness.svg', url: '/spot_icons/Wellness.svg' },
  { name: 'Shower', value: 'spot_icons/Shower.svg', url: '/spot_icons/Shower.svg' },
  { name: 'Balcony', value: 'spot_icons/Balcony.svg', url: '/spot_icons/Balcony.svg' },
  { name: 'Kitchen', value: 'spot_icons/Kitchen.svg', url: '/spot_icons/Kitchen.svg' },
  { name: 'Aircon', value: 'spot_icons/Aircon.svg', url: '/spot_icons/Aircon.svg' },
  { name: 'TV', value: 'spot_icons/TV.svg', url: '/spot_icons/TV.svg' },
  { name: 'Minibar', value: 'spot_icons/Minibar.svg', url: '/spot_icons/Minibar.svg' },
  { name: 'Workspace', value: 'spot_icons/Workspace.svg', url: '/spot_icons/Workspace.svg' },
  { name: 'Wifi', value: 'spot_icons/Wifi.svg', url: '/spot_icons/Wifi.svg' },
  { name: 'Parking', value: 'spot_icons/Parking.svg', url: '/spot_icons/Parking.svg' },
  { name: 'Transport', value: 'spot_icons/Transport.svg', url: '/spot_icons/Transport.svg' },
  { name: 'Airport Pickup', value: 'spot_icons/AirportPickup.svg', url: '/spot_icons/AirportPickup.svg' },
  { name: 'Tours', value: 'spot_icons/Tours.svg', url: '/spot_icons/Tours.svg' },
  { name: 'Parking Valet', value: 'spot_icons/ParkingValet.svg', url: '/spot_icons/ParkingValet.svg' },
  { name: 'Keycard', value: 'spot_icons/Keycard.svg', url: '/spot_icons/Keycard.svg' },
  { name: 'Safety', value: 'spot_icons/Safety.svg', url: '/spot_icons/Safety.svg' },
  { name: 'Security', value: 'spot_icons/Security.svg', url: '/spot_icons/Security.svg' },
  { name: 'Accessibility', value: 'spot_icons/Accessibility.svg', url: '/spot_icons/Accessibility.svg' },
  { name: 'Pet Friendly', value: 'spot_icons/PetFriendly.svg', url: '/spot_icons/PetFriendly.svg' },
  { name: 'Pet Care', value: 'spot_icons/PetCare.svg', url: '/spot_icons/PetCare.svg' },
  { name: 'Family', value: 'spot_icons/Family.svg', url: '/spot_icons/Family.svg' },
  { name: 'Kids', value: 'spot_icons/Kids.svg', url: '/spot_icons/Kids.svg' },
  { name: 'Kids Club', value: 'spot_icons/KidsClub.svg', url: '/spot_icons/KidsClub.svg' },
  { name: 'Laundry', value: 'spot_icons/Laundry.svg', url: '/spot_icons/Laundry.svg' },
  { name: 'Housekeeping', value: 'spot_icons/Housekeeping.svg', url: '/spot_icons/Housekeeping.svg' },
  { name: 'Events', value: 'spot_icons/Events.svg', url: '/spot_icons/Events.svg' },
  { name: 'Meeting', value: 'spot_icons/Meeting.svg', url: '/spot_icons/Meeting.svg' },
  { name: 'Conference', value: 'spot_icons/Conference.svg', url: '/spot_icons/Conference.svg' },
  { name: 'Wedding Venue', value: 'spot_icons/WeddingVenue.svg', url: '/spot_icons/WeddingVenue.svg' },
  { name: 'Business Centre', value: 'spot_icons/BusinessCentre.svg', url: '/spot_icons/BusinessCentre.svg' },
  { name: 'Co-working', value: 'spot_icons/Coworking.svg', url: '/spot_icons/Coworking.svg' },
  { name: 'Digital Services', value: 'spot_icons/DigitalServices.svg', url: '/spot_icons/DigitalServices.svg' },
  { name: 'Wine', value: 'spot_icons/Wine.svg', url: '/spot_icons/Wine.svg' },
  { name: 'Cocktail', value: 'spot_icons/Cocktail.svg', url: '/spot_icons/Cocktail.svg' },
  { name: 'Rooftop Bar', value: 'spot_icons/RooftopBar.svg', url: '/spot_icons/RooftopBar.svg' },
  { name: 'Lounge', value: 'spot_icons/Lounge.svg', url: '/spot_icons/Lounge.svg' },
  { name: 'Coffee', value: 'spot_icons/Coffee.svg', url: '/spot_icons/Coffee.svg' },
  { name: 'Breakfast Buffet', value: 'spot_icons/BreakfastBuffet.svg', url: '/spot_icons/BreakfastBuffet.svg' },
  { name: 'Event Catering', value: 'spot_icons/EventCatering.svg', url: '/spot_icons/EventCatering.svg' },
  { name: 'Dining Offers', value: 'spot_icons/DiningOffers.svg', url: '/spot_icons/DiningOffers.svg' },
  { name: 'Entertainment', value: 'spot_icons/Entertainment.svg', url: '/spot_icons/Entertainment.svg' },
  { name: 'Live Music', value: 'spot_icons/LiveMusic.svg', url: '/spot_icons/LiveMusic.svg' },
  { name: 'Wedding', value: 'spot_icons/Wedding.svg', url: '/spot_icons/Wedding.svg' },
  { name: 'Tickets', value: 'spot_icons/Tickets.svg', url: '/spot_icons/Tickets.svg' },
  { name: 'Scenic View', value: 'spot_icons/ScenicView.svg', url: '/spot_icons/ScenicView.svg' },
  { name: 'Shopping', value: 'spot_icons/Shopping.svg', url: '/spot_icons/Shopping.svg' },
  { name: 'Bike Hire', value: 'spot_icons/BikeHire.svg', url: '/spot_icons/BikeHire.svg' },
  { name: 'Guidebook', value: 'spot_icons/Guidebook.svg', url: '/spot_icons/Guidebook.svg' },
  { name: 'Library', value: 'spot_icons/Library.svg', url: '/spot_icons/Library.svg' },
  { name: 'Languages', value: 'spot_icons/Languages.svg', url: '/spot_icons/Languages.svg' },
  { name: 'Payments', value: 'spot_icons/Payments.svg', url: '/spot_icons/Payments.svg' },
  { name: 'Pharmacy', value: 'spot_icons/Pharmacy.svg', url: '/spot_icons/Pharmacy.svg' },
  { name: 'Medical', value: 'spot_icons/Medical.svg', url: '/spot_icons/Medical.svg' },
  { name: 'Butler', value: 'spot_icons/Butler.svg', url: '/spot_icons/Butler.svg' },
  { name: 'Beach Club', value: 'spot_icons/BeachClub.svg', url: '/spot_icons/BeachClub.svg' },
  { name: 'Sunrise', value: 'spot_icons/Sunrise.svg', url: '/spot_icons/Sunrise.svg' },
  { name: 'Concierge', value: 'spot_icons/Concierge.svg', url: '/spot_icons/Concierge.svg' },
  { name: 'Reception', value: 'spot_icons/Reception.svg', url: '/spot_icons/Reception.svg' },
  { name: 'Room Service', value: 'spot_icons/RoomService.svg', url: '/spot_icons/RoomService.svg' },
  { name: 'Shuttle', value: 'spot_icons/Shuttle.svg', url: '/spot_icons/Shuttle.svg' },
  { name: 'EV Charger', value: 'spot_icons/EVCharger.svg', url: '/spot_icons/EVCharger.svg' },
  { name: 'Gym', value: 'spot_icons/Gym.svg', url: '/spot_icons/Gym.svg' },
  { name: 'Location', value: 'spot_icons/Location.svg', url: '/spot_icons/Location.svg' },
  { name: 'Bag', value: 'spot_icons/Bag.svg', url: '/spot_icons/Bag.svg' },
  { name: 'Key', value: 'spot_icons/Key.svg', url: '/spot_icons/Key.svg' },
  { name: 'List', value: 'spot_icons/List.svg', url: '/spot_icons/List.svg' },
  { name: 'Power', value: 'spot_icons/Power.svg', url: '/spot_icons/Power.svg' },
  { name: 'Star', value: 'spot_icons/Star.svg', url: '/spot_icons/Star.svg' },
  { name: 'Tub', value: 'spot_icons/Tub.svg', url: '/spot_icons/Tub.svg' },
];

const mergeLocalIcons = (icons = []) => {
  const byValue = new Map();

  [...LOCAL_ICON_OVERRIDES, ...icons].forEach((icon) => {
    if (!icon?.value) return;
    byValue.set(icon.value, icon);
  });

  return Array.from(byValue.values());
};

const normalize = (raw) => {
  // 新结构：{ base_url, icons: [{ name, value }...] }
  if (raw && Array.isArray(raw.icons)) {
    return {
      baseUrl: raw.base_url || DEFAULT_BASE_URL,
      icons: mergeLocalIcons(raw.icons.map(x => ({
        name: x.name,
        value: x.value,
        url: x.url
      })))
    };
  }
  return { baseUrl: DEFAULT_BASE_URL, icons: mergeLocalIcons([]) };
};

const readCache = () => {
  try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null'); }
  catch { return null; }
};

const writeCache = (data, etag) => {
  localStorage.setItem(LS_KEY, JSON.stringify({ data, etag, ts: Date.now() }));
};

export async function loadIconSource(manifestUrl = DEFAULT_MANIFEST_URL) {
  // 1) 先尝试读取缓存
  const cached = readCache();
  if (cached?.data) {
    // 异步刷新（如果有 ETag）
    refreshInBackground(manifestUrl, cached.etag).catch(() => {});
    return normalize(cached.data); // 先返回缓存，并补齐本地图标
  }
  // 2) 无缓存：直接拉
  try {
    const res = await fetch(manifestUrl);
    if (!res.ok) throw new Error(`Manifest fetch failed: ${res.status}`);
    const raw = await res.json();
    const data = normalize(raw);
    const etag = res.headers.get('ETag') || null;
    writeCache(data, etag);
    return data;
  } catch {
    // 3) 失败：fallback 到本地数组
    return normalize(localArray);
  }
}

async function refreshInBackground(manifestUrl, previousEtag) {
  const headers = previousEtag ? { 'If-None-Match': previousEtag } : {};
  const res = await fetch(manifestUrl, { headers });
  if (res.status === 304) return; // 未变化
  if (!res.ok) throw new Error(`Manifest refresh failed: ${res.status}`);
  const raw = await res.json();
  const data = normalize(raw);
  const etag = res.headers.get('ETag') || null;
  writeCache(data, etag);
}
